// import { findResAst, getImageObject, getRefName } from '../utils';

export function SlotLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  colors: StoreThemeColorItem[]
) {
  // 应用小组件
  if (layerAst.attrsMap.type === 'appWidget') {
    layer.type = 'AppWidget';
    layer.attrs.appWidget = layerAst.attrsMap.appWidgetID;
    return;
  }

  // layerAst.children.forEach((item) => {
  //   let editBox: Record<string, string[]> = {};
  //   editBox = getImageObject(
  //     resAst,
  //     getRefName(
  //       findResAst(resAst, getRefName(item.attrsMap.ref))?.[0]?.attrsMap.editBox
  //     ),
  //     colors
  //   );

  //   if (Object.keys(editBox).length > 0) {
  //     layer.attrs.resources = {
  //       editBox
  //     };
  //     return;
  //   }
  // });

  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };
  layer.attrs.slotType = layerAst.attrsMap.type;
}
